import { EntityStore } from '../../../shared/stores/EntityStore';
import { action, makeObservable } from 'mobx';
import { api } from '../../../shared/api/api';

class JobRoleStore extends EntityStore {
	constructor() {
		super('job-roles');
		makeObservable(this);
	}

	@action
	async getJobRoles(query) {
		const url = this.entityPluralEndpoint + '?q=' + query;
		const result = await api.get(encodeURI(url));
		return result;
	}
}

export const jobRoleStore = new JobRoleStore();
